export const globalHelperStyles = `
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.modal-scroll-hidden::-webkit-scrollbar {
  display: none;
}

.modal-scroll-hidden {
  -ms-overflow-style: none;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}
`;